import React from 'react'
import { PersistGate } from 'redux-persist/integration/react'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { I18nextProvider } from 'react-i18next'
import i18n from 'utils/i18n'
import Application from 'components/application/Application'
import { persistedStore, store } from 'components/store/state/store'
import { AvailableLanguage, ITreatment } from 'components/core/types'

interface AppProps {
  lang: AvailableLanguage,
  treatments: ITreatment[],
  hideUrl: boolean,
}

function App({ lang, treatments, hideUrl }: AppProps) {
  i18n.changeLanguage(lang)
  return (
    <BrowserRouter>
      <Provider store={store}>
        <PersistGate persistor={persistedStore}>
          <I18nextProvider i18n={i18n}>
            <Application lang={lang} treatments={treatments} hideUrl={hideUrl} />
          </I18nextProvider>
        </PersistGate>
      </Provider>
    </BrowserRouter>
  )
}
export default App
